import { createAsyncActionTypes } from 'misc/utils';

export const MANAGER_BOOTSTRAP = createAsyncActionTypes('bootstrap/MANAGER');
export const EMPLOYEE_BOOTSTRAP = createAsyncActionTypes('bootstrap/EMPLOYEE');